
export default function () {
    return function (value) {
        const phone = value;
        return !!phone && !!(phone.replace(/\D/g, '').match('^[+]*38(0)([0-9]{1}[0-9]{8})$'));

    }
}
